// extracted by mini-css-extract-plugin
export var calendarView = "_60-0";